import { useState, useEffect } from 'react';
import ApiServiceV2 from '../services/ApiServiceV2';
import { routes } from './routes';

export const useShopUrl = (): string => {
    const [shopUrl, setShopUrl] = useState('');

    useEffect(() => {
        const loadShopUrl = async () => {
            try {
                const api = new ApiServiceV2();
                const response = await api.callApi(routes.server);
                if (response.data?.data?.url) {
                    setShopUrl(response.data.data.url);
                }
            } catch (error) {
                console.error('Failed to load shop URL:', error);
            }
        };

        loadShopUrl();
    }, []);

    return shopUrl;
};


